import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStepNotStarted = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			transform: "translate(0.400391 0.000976562)",
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.40039,
			cy: 8.00098,
			r: 7,
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "1 3"
		})
	]
});
const ForwardRef = forwardRef(SvgStepNotStarted);
export default ForwardRef;
